'use strict';

exports.__esModule = true;

var _utils = require('../utils');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * Created by @玩家 on 2017/2/7.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */


var Stream = void 0;

exports['default'] = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(req) {
        var headers, method, url, serializeData, dataType, type, timeout, weexType, options;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (!Stream) {
                            __weex_define__('@alife/puck', function (__weex_require__) {
                                Stream = __weex_require__('@weex-module/stream');
                            });
                        }

                        headers = req.headers, method = req.method, url = req.url, serializeData = req.serializeData, dataType = req.dataType, type = req.type, timeout = req.timeout;
                        weexType = type === 'normal' ? dataType : 'jsonp';
                        options = { url: url, method: method, headers: headers, type: weexType };

                        if (method !== 'GET') {
                            options.body = serializeData;
                        }

                        _context.next = 7;
                        return Promise.race([weexRequest(options), (0, _utils.delay)(timeout)]);

                    case 7:
                        return _context.abrupt('return', _context.sent);

                    case 8:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    function weexFetcher(_x) {
        return _ref.apply(this, arguments);
    }

    return weexFetcher;
}();

function weexRequest(options) {
    return new Promise(function (resolve, reject) {
        Stream.fetch(options, function (ret) {
            var status = ret.status,
                ok = ret.ok,
                statusText = ret.statusText,
                data = ret.data,
                headers = ret.headers;

            resolve({ status: status, ok: ok, statusText: statusText, headers: headers, body: data });
        });
    });
}
module.exports = exports['default'];